module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Money-106359059649c2517a58e5595e8dd82f.svg";